function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { media, themeGet } from "sprout-ui-theme";
import { Box } from "sprout-ui-primitives";
import styled from "styled-components";
import { Popover as BasePopover } from "../Popover";
const Popover = styled(BasePopover)`
  ${media.down("medium")} {
    top: 54px !important;
    left: 50% !important;
    transform: translateX(-50%) !important;
  }

  ${media.down("small")} {
    top: 0 !important ;
    left: 0 !important;
    bottom: 0 !important;
    right: 0 !important;
    transform: none !important;
  }
`;
const PopoverDialogWrapper = styled(Box)`
  color: ${themeGet("colors.white.100")};
  background: ${themeGet("colors.blue.500")};

  ${media.down("small")} {
    height: 100%;
  }

  ${media.up("small")} {
    width: 400px;
    border-radius: 30px;
    max-height: calc(100% - 80px);
    padding: 0 16px;
    box-shadow: 0 1px 4px ${themeGet("colors.black.16")};
  }
`;
var PopoverDialog = (props)=>{
    const { children  } = props, rest = _objectWithoutProperties(props, [
        "children"
    ]);
    return /*#__PURE__*/ _jsx(Popover, _objectSpread({}, rest, {
        children: /*#__PURE__*/ _jsx(PopoverDialogWrapper, {
            children: children
        })
    }));
};
export { PopoverDialog };
